import { collection, getDocs } from 'firebase/firestore';
import db from '../lib/firebaseDb';

// Define the Cuisine interface
export interface Cuisine {
  id: string;
  name: string;
  description: string;
  category: string;
  region?: string;
  imageUrl: string;
  ingredients?: string[];
  recipe?: string;
}

// Fetch all cuisine data
export const fetchCuisine = async (): Promise<Cuisine[]> => {
  try {
    const querySnapshot = await getDocs(collection(db, 'cuisine'));
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Cuisine[];
  } catch (error) {
    console.error('Error fetching cuisine data:', error);
    throw error;
  }
};

// Fetch cuisine by category
export const fetchCuisineByCategory = async (category: string): Promise<Cuisine[]> => {
  try {
    const cuisineData = await fetchCuisine();
    return cuisineData.filter(item => item.category === category);
  } catch (error) {
    console.error('Error fetching cuisine by category:', error);
    throw error;
  }
};

// Fetch cuisine by region
export const fetchCuisineByRegion = async (region: string): Promise<Cuisine[]> => {
  try {
    const cuisineData = await fetchCuisine();
    return cuisineData.filter(item => item.region === region);
  } catch (error) {
    console.error('Error fetching cuisine by region:', error);
    throw error;
  }
}; 